export default "__VITE_ASSET__xblYWB0D__"